import { Environment } from './environment.d'

export const localEnvironment: Environment = {
  host: "localhost",
  port: 3000,
  protocol: "http",
  production: false,
  basePath: "/"
}
